import { Record } from "../../../../appworks/model/gameplay/records/record";

export class GambleRecord extends Record {
    public id: string = "GambleRecord";
    public collect: boolean;
}
